<script setup lang="ts">
import { computed, type HTMLAttributes } from "vue";
import { cn } from "@/lib/utils";

interface Props extends /* @vue-ignore */ HTMLAttributes {
  class?: string;
}

const props = defineProps<Props>();

const classes = computed(() =>
  cn("animate-pulse rounded-lg bg-app-border", props.class),
);
</script>

<template>
  <div :class="classes" />
</template>
